import { useEffect, useState } from "react";
import { TCourseCategory } from "../@types";
import { apis, callApi } from "../api";

export type TCourseCategoryService = {
	listeners: (() => void)[];
	categories: TCourseCategory[];

	addEventListener: (cb: () => void) => void;
	removeEventListener: (cb: () => void) => void;
	emitChanges: () => void;
	clearData: () => void;

	setCategories: (categories: TCourseCategory[]) => void;
};

export const CourseCategoryService: TCourseCategoryService = {
	listeners: [],
	categories: [],

	addEventListener(cb) {
		this.listeners = this.listeners.filter((listener) => listener !== cb);
		this.listeners.push(cb);
	},

	setCategories(categories) {
		this.categories = categories;
	},

	emitChanges() {
		for (const listener of this.listeners) {
			listener();
		}
	},

	removeEventListener(cb) {
		this.listeners = this.listeners.filter((listener) => listener !== cb);
	},

	clearData() {
		this.categories = [];
		this.emitChanges();
	},
};

export function useCourseCategoriesInit() {
	useEffect(() => {
		const getCategories = async () => {
			try {
				const categoryResponse = await callApi({
					method: "GET",
					url: apis.COURSE_CATEGORIES,
				});

				if (categoryResponse?.categories) {
					CourseCategoryService.setCategories(
						categoryResponse.categories ?? [],
					);
					CourseCategoryService.emitChanges();
				}
			} catch (error) {}
		};

		getCategories();
	}, []);
}

export function useCourseCategories() {
	const [categories, setCategories] = useState(
		CourseCategoryService.categories,
	);

	useEffect(() => {
		const updateData = () => {
			setCategories(CourseCategoryService.categories);
		};

		CourseCategoryService.addEventListener(updateData);

		return () => {
			CourseCategoryService.removeEventListener(updateData);
		};
	}, []);

	return { categories };
}
